<script>
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import location from './Indow-Location-Portland-Map.png';

	let { bgColor = 'blue' } = $props();
</script>

<Section backgroundColor={bgColor}>
	<h2>Our Location</h2>
	<Grid gap={4}>
		<Grid vertical gap={1.5}>
			<a
				href="https://g.page/Indow?share"
				target="_"
				rel="noopener noreferrer"
				class="w-48 place-self-center"
			>
				<Image
					src={location}
					alt="Map showing Indow factory location in portland."
				/>
			</a>
			<p>
				<a
					href="https://goo.gl/maps/kkDCc"
					target="_"
					rel="noopener noreferrer"
				>
					Click for a larger map
				</a>
				<br />
				<a
					href="http://trimet.org/go/cgi-bin/plantrip.cgi?to=6427%20NE%59th%20Pl,%20Portland,%20OR%2097218"
					target="_"
					rel="noopener noreferrer">Find TriMet route</a
				>
			</p>
		</Grid>

		<Grid vertical gap={1.5} rows={3} class="justify-items-start">
			<p>We are a Portland-based company serving the U.S. and Canada</p>
			<Grid as="p" vertical rows={2} gap={0} class="text-start">
				<span>
					Email <a href="mailto:opportunity@indowwindows.com"
						>opportunity@indowwindows.com</a
					>
				</span>
				<span>
					Call <a href="tel:(503) 284-2260">(503) 284-2260</a>
				</span>
			</Grid>
			<Grid as="p" vertical gap={0} rows={3} class="text-start">
				<span>Send us a letter</span>
				<a
					href="https://goo.gl/maps/Mr7r1hrR6QL2"
					target="_blank"
					rel="noreferrer"
					>6427 NE 59th Place<br />
					Portland, OR 97218</a
				>
				<span>(visits to our facility are by appointment only)</span>
			</Grid>
		</Grid>
	</Grid>
</Section>
